var map = {
	"./arrow-right.svg": 705,
	"./boxberry.svg": 49,
	"./cart.svg": 178,
	"./cdek.svg": 546,
	"./close.svg": 688,
	"./dhl.svg": 314,
	"./dpd.svg": 112,
	"./fb.svg": 747,
	"./google.svg": 408,
	"./insta.svg": 931,
	"./like-inactive.svg": 871,
	"./like.svg": 401,
	"./lk.svg": 904,
	"./lock.svg": 100,
	"./logo.svg": 831,
	"./minus.svg": 411,
	"./onlyfans.svg": 592,
	"./pin.svg": 382,
	"./plus-2.svg": 510,
	"./plus.svg": 127,
	"./pochta.svg": 837,
	"./preloader.svg": 998,
	"./success.svg": 255,
	"./telegram.svg": 35,
	"./tik-tok.svg": 471,
	"./twitter.svg": 254,
	"./vk.svg": 324,
	"./youtube.svg": 241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 549;